import { CategoryBottomBanner, CategoryDescription, CategoryNotFound, CategoryTopBanner, Facets, ProductGrid, SchemaMarkup, SignOut, ToolBar, WebEngagePageViewEvent } from "@repo/components";
import { getFeatureFlag } from "@repo/lib/utils";
import { BreadCrumb, Pagination } from "@repo/ui";
const CategoryPageLayout = async ({
  t,
  session,
  wishlist,
  initialColumns,
  pageNumber,
  totalElements,
  sortOptions,
  selectedSort,
  appliedFilters,
  facets,
  lineItems,
  name,
  description,
  bottomDesktopBanners,
  bottomMobileBanners,
  topDesktopBanners,
  topMobileBanners,
  updatedBreadcrumbs,
  collectionName,
  slug,
  spaceSlug,
  categorySchema,
  isUnauthorized = false
}) => {
  if (isUnauthorized) return <SignOut isUnauthorized />;
  const isWebEngageEnabled = getFeatureFlag("webEngage");
  return <>
      {isWebEngageEnabled && <WebEngagePageViewEvent eventName="category_viewed" eventData={{
      collection: slug
    }} />}
      {/* Top Banner */}
      <CategoryTopBanner topDesktopBanners={topDesktopBanners} topMobileBanners={topMobileBanners} categoryName={name} totalCount={totalElements} data-sentry-element="CategoryTopBanner" data-sentry-source-file="CategoryPageLayout.jsx" />
      <div className="px-4">
        <div className="mx-auto md:max-w-screen-xl" key={pageNumber}>
          <BreadCrumb items={updatedBreadcrumbs} data-sentry-element="BreadCrumb" data-sentry-source-file="CategoryPageLayout.jsx" />
          <>
            {!!facets && <ToolBar sortOptions={sortOptions} selectedSort={selectedSort} appliedFilters={appliedFilters} facets={<Facets facets={facets} />} initialColumns={initialColumns} isLineItemsExist={!!lineItems?.length} />}
            <div className="pb-4">
              <div className="flex">
                <div className="w-full">
                  {lineItems.length ? <>
                      <div className="pb-6">
                        <ProductGrid products={lineItems} wishlistItems={wishlist?.content} session={session} initialColumns={initialColumns} collectionName={collectionName} categorySlug={slug} spaceSlug={spaceSlug} // optional — used only on Setup page
                    />
                      </div>
                      <Pagination pageNumber={pageNumber} totalCount={totalElements} />
                      {description && <CategoryDescription description={description} />}
                    </> : <CategoryNotFound />}
                </div>
              </div>
            </div>
            {/* Bottom Banner */}
            <CategoryBottomBanner bottomDesktopBanners={bottomDesktopBanners} bottomMobileBanners={bottomMobileBanners} categoryName={name} data-sentry-element="CategoryBottomBanner" data-sentry-source-file="CategoryPageLayout.jsx" />
          </>
        </div>
      </div>
      <SchemaMarkup schema={categorySchema} id="category-schema" data-sentry-element="SchemaMarkup" data-sentry-source-file="CategoryPageLayout.jsx" />
    </>;
};
export default CategoryPageLayout;